import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  ButtonGroup,
  OutlinedInput,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  withStyles,
  useTheme,
  commonService,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  AddBoxIcon,
  SearchIcon,
  ClearIcon,
  AddIcon,
  SpeedIcon,
} from "../../../common";

import FilterListIcon from "@material-ui/icons/FilterList";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "5rem",
  },
  btnStyle: {
    backgroundColor: "#1DBF73",
    color: "white",
    fontWeight: "400",
    "&:hover": {
      backgroundColor: "#11a962",
    },
  },
  listIcon: { width: 20, paddingRight: theme.spacing(0.5) },

  table: {
    marginTop: "1.5rem",
  },
  rowPadding: {
    padding: "0.125rem 0.25rem 0 0",
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  link: {
    display: "flex",
    textDecoration: "none",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  active: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#1DBF73",
    backgroundColor: "#1DBF7333",
  },
  disabled: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#BEBDBD",
  },
  borderRemove: {
    borderBottom: "none",
    paddingLeft: "0",
  },
  btnIcon: {
    paddingRight: "5px",
    fontSize: "20px",
  },
}));
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
export default function Limit() {
  const classes = useStyles();
  const classes1 = useStyles1();
  const theme = useTheme();
  const [userTypeList, setUserTypeList] = useState([]);
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const [limitTypeList, setLimitTypeList] = useState([]);

  const [transactionType, setTransactionType] = useState("");
  const [level, setLevel] = useState("");
  const [userType, setUserType] = useState("");
  const [limit, setLimit] = useState("");
  const [noOfTransaction, setNoOfTransaction] = useState("");
  const [transactionAmount, setTransactionAmount] = useState([]);
  const [levelTypeList, setLevelTypeList] = useState([]);
  const [limitList, setLimitList] = useState([]);

  const [count, setCount] = React.useState(20);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(16);
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dataTableIsLoading, setDataTableIsLoading] = React.useState(true);
  const [status, setStatus] = useState("");

  const [filterShow, setFilterShow] = useState(false);

  const limitInactiveHandler = async (e, id, status) => {
    let requestObj = {
      limit_id: id,
      status: status,
    };
    const res = await commonService.updateLimit(requestObj);
    //  console.log("update limit", res);
    res?.code === 200 && setOpen(true);
    setSuccessMsgBody(res.messages);
    handleSearch(page, userType, level, limit, transactionType);
    res?.code !== 200 && setError(true);
    setErrorMsgBody(res.messages[0]);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const handleSearch = async () => {
    setDataTableIsLoading(true);
    setLimitList([]);
    const res = await commonService.getLimitList(
      page,
      userType,
      level,
      limit,
      transactionType,
      status
    );
    if (res.code === 200 && res.data.limits.length === 0) {
      setError(true);
      setErrorMsgBody("No Data Found");
      setDataTableIsLoading(false);
    } else if (res.code === 200) {
      setLimitList(res && res.data && res.data.limits);
      setDataTableIsLoading(false);
    } else {
      setError(true);
      setErrorMsgBody(res.messages[0]);
      setDataTableIsLoading(false);
    }
  };

  const StyledTableCell = withStyles((theme) => ({
    root: {
      //   padding: '0.125rem 0.25rem',
    },
    head: {
      backgroundColor: theme.palette.common.white,
      fontSize: "1.125rem",
      letterSpacing: "0.014375rem",
      fontWeight: "500",
      color: "#2B335E",
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleBackButtonClick = (event) => {
      setLimitList([]);

      onChangePage(event, page - 1);

      commonService
        .getLimitList(page - 1, userType, level, limit, transactionType)
        .then((res) => {
          if (res.code === 200 && res.data.limits.length === 0) {
            setError(true);
            setErrorMsgBody("No Data Found");
          } else if (res.code === 200) {
            setLimitList(res && res.data && res.data.limits);
          } else {
            setError(true);
            setErrorMsgBody(res.messages[0]);
          }
        });
    };

    const handleNextButtonClick = (event) => {
      setLimitList([]);
      setCount(count + parseInt(20));
      onChangePage(event, page + 1);
      commonService
        .getLimitList(page + 1, userType, level, limit, transactionType)
        .then((res) => {
          if (res.code === 200 && res.data.limits.length === 0) {
            setError(true);
            setErrorMsgBody("No Data Found");
          } else if (res.code === 200) {
            setLimitList(res && res.data && res.data.limits);
          } else {
            setError(true);
            setErrorMsgBody(res.messages[0]);
          }
        });
    };

    // const handleLastPageButtonClick = (event) => {
    //   onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    // };

    return (
      <div className={classes1.root}>
        {/* <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton> */}
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        {/* <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton> */}
      </div>
    );
  };

  const ClearBtn = () => {
    setUserType("");
    setLevel("");
    setLimit("");
    setTransactionType("");
    setNoOfTransaction("");
    setTransactionAmount("");
    setStatus("");
  };

  const handleChangePage = (event, newPage) => {
    //  console.log("newpage", newPage);
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    //  console.log("rowperpage", event);
    setRowsPerPage(parseInt(event.target.value, 15));
    setPage(0);
  };

  const getUserTypes = async () => {
    const userType = await commonService.getUserType();
    setUserTypeList(userType.data?.user_types);
  };

  const getLimitsType = async () => {
    const limitType = await commonService.getLimitType();
    setLimitTypeList(limitType.data?.limit_types);
  };

  useEffect(() => {
    getUserTypes();
    getLimitsType();

    handleSearch();
  }, []);

  const getTransactionTypeList = async (sender) => {
    const transactionType = await commonService.getTransactionTypeLimit(sender);
    setTransactionTypeList(transactionType.data?.transaction_types);
  };

  const getLevelsList = async (user_type_id) => {
    const levelType = await commonService.getLevel(user_type_id);
    setLevelTypeList(levelType.data?.levels);
  };

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
        <NavLink
          to="/dashboard"
          style={{ color: "#2B335E99" }}
          className={classes.link}
        >
          <HomeIcon className={classes.icon} />
          Home
        </NavLink>
        <NavLink
          to="/limit/view-all"
          style={{ color: "#2B335E99" }}
          className={classes.link}
        >
          <SpeedIcon className={classes.icon} />
          Limit
        </NavLink>
        <Typography style={{ color: "#2B335E" }} className={classes.link}>
          <AddBoxIcon className={classes.listIcon} /> List
        </Typography>
      </Breadcrumbs>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          style={{
            textAlign: "left",
            margin: "15px 0",
            color: "#2B335E",
            fontSize: "25px",
          }}
        >
          Overall Limit List
        </Typography>

        <div>
          <NavLink
            to="/limit/create"
            variant="contained"
            style={{ height: "30px", textDecoration: "none", float: "right" }}
          >
            <Button
              className="btn btn-primary btn-block"
              size="medium"
              variant="contained"
            >
              <AddIcon style={{ paddingRight: "5px" }} /> Create Limit
            </Button>
          </NavLink>

          <Button
            size="medium"
            variant="contained"
            color="primary"
            className="btn btn-primary"
            style={{ float: "right", marginRight: 10 }}
            onClick={(e) => setFilterShow(!filterShow)}
          >
            <FilterListIcon style={{ paddingRight: "5px" }} />
          </Button>
        </div>
      </div>

      {filterShow && (
        <Paper style={{ padding: "20px" }}>
          <Typography
            style={{
              textAlign: "left",
              marginBottom: "10px",
              color: "#2B335E",
              fontSize: "21px",
            }}
          >
            Filter by
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="userType"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  User Type
                </InputLabel>
                <Select
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={userType}
                  onChange={(e) => {
                    setUserType(e.target.value);
                    if (e.target.value !== "") {
                      getTransactionTypeList(e.target.value);
                      getLevelsList(e.target.value);
                    }
                  }}
                  label="User Type"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {userTypeList.map((user) => (
                    <MenuItem value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="transactionType"
              >
                <InputLabel id="transactionType">Transaction Type</InputLabel>
                <Select
                  labelid="transactionType"
                  id="transactionType"
                  value={transactionType}
                  label="Transaction Type"
                  onChange={(e) => setTransactionType(e.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {transactionTypeList.map((user) => (
                    <MenuItem value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="transactionType"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Status
                </InputLabel>
                <Select
                  label="Status"
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                label="Receiver is"
                id="receiver"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Level
                </InputLabel>
                <Select
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  label="Level"
                  value={level}
                  onChange={(e) => setLevel(e.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {levelTypeList.map((user) => (
                    <MenuItem value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="noOfTransaction"
                label="Number of Transaction"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Number of Transaction
                </InputLabel>
                <OutlinedInput
                  value={noOfTransaction}
                  onChange={(e) => setNoOfTransaction(e.target.value)}
                  fullWidth
                  id="noOfTransaction"
                  type="text"
                  label="Number of Transaction"
                  inputComponent="input"
                  variant="outlined"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                label="Limit"
                id="limit"
              >
                <InputLabel id="limit">Limit</InputLabel>
                <Select
                  labelid="limit"
                  id="limit"
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                  label="Limit"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {limitTypeList.map((user) => (
                    <MenuItem value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="transactionAmount"
              >
                <InputLabel id="transactionAmount">
                  Transaction Amount
                </InputLabel>
                <OutlinedInput
                  labelid="transactionAmount"
                  label="Transaction Amount"
                  id="transactionAmount"
                  value={transactionAmount}
                  onChange={(e) => setTransactionAmount(e.target.value)}
                ></OutlinedInput>
              </FormControl>
            </Grid>
          </Grid>
          <Divider style={{ margin: "10px 0" }} />
          <Grid
            item
            container
            xl={12}
            justify="flex-end"
            alignItems="flex-end"
            className={classes.btnContainer}
          >
            <Box mr={5}>
              <Button
                variant="contained"
                className={classes.cancelBtn}
                onClick={ClearBtn}
              >
                <ClearIcon className={classes.btnIcon} /> Clear
              </Button>
            </Box>
            <Box mr={3} mt={2}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSearch}
                className="btn btn-primary btn-block"
              >
                <SearchIcon className={classes.btnIcon} />
                Filter
              </Button>
            </Box>
          </Grid>
        </Paper>
      )}

      {dataTableIsLoading === true ? (
        <Box mt={15}>
          {" "}
          <CircularProgress
            size={80}
            className={classes.progress}
            thickness={2}
          />
        </Box>
      ) : (
        <TableContainer component={Paper} className={classes.table}>
          {limitList && limitList.length > 0 && (
            <>
              <Table
                aria-labelledby="tableTitle"
                size="small"
                padding="default"
                aria-label="simple table"
                //     style={{ width: "max-content" }}
              >
                <TableHead>
                  <TableRow
                    className={classes.tableHeader}
                    style={{ height: "70px" }}
                  >
                    <StyledTableCell>User Type</StyledTableCell>
                    <StyledTableCell>Level</StyledTableCell>
                    <StyledTableCell>Transaction Type</StyledTableCell>
                    <StyledTableCell>Currency</StyledTableCell>
                    <StyledTableCell>Limit Type</StyledTableCell>
                    <StyledTableCell>No. Of Transaction</StyledTableCell>
                    <StyledTableCell>Transaction Amount</StyledTableCell>
                    <StyledTableCell>Created At</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {limitList &&
                    limitList.length > 0 &&
                    limitList.map((item) => (
                      <>
                        <StyledTableRow
                          key={item.id}
                          style={{ cursor: "pointer" }}
                        >
                          <StyledTableCell>{item.user_type}</StyledTableCell>
                          <StyledTableCell>{item.level}</StyledTableCell>
                          <StyledTableCell>
                            {" "}
                            {item.transaction_type}
                          </StyledTableCell>
                          <StyledTableCell>
                            {item.currency_code}
                          </StyledTableCell>
                          <StyledTableCell>
                            {item &&
                              item.data &&
                              item.data.length > 0 &&
                              item.data.map((limitData) => (
                                <Table>
                                  <TableRow>
                                    <StyledTableCell
                                      className={classes.borderRemove}
                                    >
                                      {" "}
                                      {limitData.limit_type}
                                    </StyledTableCell>
                                  </TableRow>
                                </Table>
                              ))}
                          </StyledTableCell>
                          <StyledTableCell>
                            {item &&
                              item.data &&
                              item.data.length > 0 &&
                              item.data.map((limitData) => (
                                <Table>
                                  <TableRow>
                                    <StyledTableCell
                                      className={classes.borderRemove}
                                    >
                                      {" "}
                                      {limitData.max_number_of_tx}
                                    </StyledTableCell>
                                  </TableRow>
                                </Table>
                              ))}
                          </StyledTableCell>
                          <StyledTableCell>
                            {item &&
                              item.data &&
                              item.data.length > 0 &&
                              item.data.map((limitData) => (
                                <Table>
                                  <TableRow>
                                    <StyledTableCell
                                      className={classes.borderRemove}
                                    >
                                      {" "}
                                      {limitData.max_tx_amount}
                                    </StyledTableCell>
                                  </TableRow>
                                </Table>
                              ))}
                          </StyledTableCell>
                          <StyledTableCell>
                            {item &&
                              item.data &&
                              item.data.length > 0 &&
                              item.data.map((limitData) => (
                                <Table>
                                  <TableRow>
                                    <StyledTableCell
                                      className={classes.borderRemove}
                                    >
                                      {" "}
                                      {limitData.created_at}
                                    </StyledTableCell>
                                  </TableRow>
                                </Table>
                              ))}
                          </StyledTableCell>
                          <StyledTableCell>
                            {item &&
                              item.data &&
                              item.data.length > 0 &&
                              item.data.map((limitData) => (
                                <Table>
                                  <TableRow>
                                    <StyledTableCell
                                      className={classes.borderRemove}
                                    >
                                      {" "}
                                      {limitData.status === "Active" ? (
                                        <ButtonGroup
                                          size="small"
                                          aria-label="small outlined button group"
                                        >
                                          <Button className={classes.active}>
                                            Active
                                          </Button>
                                          <Button
                                            className={classes.disabled}
                                            onClick={(e) =>
                                              limitInactiveHandler(
                                                e,
                                                limitData.id,
                                                0
                                              )
                                            }
                                          >
                                            Inactive
                                          </Button>
                                        </ButtonGroup>
                                      ) : (
                                        <ButtonGroup
                                          size="small"
                                          aria-label="small outlined button group"
                                        >
                                          <Button
                                            className={classes.disabled}
                                            onClick={(e) =>
                                              limitInactiveHandler(
                                                e,
                                                limitData.id,
                                                1
                                              )
                                            }
                                          >
                                            Active
                                          </Button>
                                          <Button className={classes.active}>
                                            Inactive
                                          </Button>
                                        </ButtonGroup>
                                      )}
                                    </StyledTableCell>
                                  </TableRow>
                                </Table>
                              ))}
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                showfirstbutton="true"
                showlastbutton="true"
                component="div"
                count={count}
                pagesize={15}
                // rowsPerPageOptions={[]}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                ActionsComponent={TablePaginationActions}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </>
          )}

          {limitList && limitList.length <= 0 && (
            <Table
              aria-labelledby="tableTitle"
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow
                  className={classes.tableHeader}
                  style={{ height: "70px" }}
                >
                  <StyledTableCell>User Type</StyledTableCell>
                  <StyledTableCell>Level</StyledTableCell>
                  <StyledTableCell>Transaction Type</StyledTableCell>
                  <StyledTableCell>Currency</StyledTableCell>
                  <StyledTableCell>Limit Type</StyledTableCell>
                  <StyledTableCell>No. Of Transaction</StyledTableCell>
                  <StyledTableCell>Transaction Amount</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <StyledTableRow>
                  <StyledTableCell style={{ backgroundColor: "white" }}>
                    <h6 className="p-4">No data found!</h6>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          )}
        </TableContainer>
      )}
    </Container>
  );
}
